/// <reference path='../_all.ts' />

module library {

  export class XYDimensions {
    constructor(
      public x: any,
      public y: any
    ) { }
  }

  export class ImageTemplate {
    constructor(
      public description: string,
      public megapixel: number,
      public sizeUnit: string,
      public dpi: number
    ) { }
  }
}